import { Subject } from 'rxjs';
import { EventBody } from './web.socket.response.types';
import { IWebSocketSubscription } from './web.socket.instance.interface';

export class WebSocketSubscriptionNoop implements IWebSocketSubscription {
  public onEventReceived: Subject<EventBody> = new Subject<EventBody>();
  public onDestroy: Subject<string> = new Subject();

  constructor(private channel: string) {
    // No-op implementation - immediately complete subjects
    setTimeout(() => {
      this.onDestroy.next(this.channel);
      this.onDestroy.complete();
      this.onEventReceived.complete();
    }, 0);
  }

  public reconnect(): void {
    // No-op implementation
  }

  public destroy(): void {
    // No-op implementation - just complete the subjects
    this.onDestroy.next(this.channel);
    this.onDestroy.complete();
    this.onEventReceived.complete();
  }
}
